import { gql } from "@apollo/client";

export const CANCEL_VEHICLE_SERVICE = gql`
  mutation cancelVehicleService($cancelService: CancelVehicleServiceInput!) {
    cancelVehicleService(cancelService: $cancelService) {
        success    
    }
}
`;